<template>
  <div>
    <div style="width: 100%" :style="{ height: height }" v-bind:id="id"></div>
  </div>
</template>

<script>
import { getUUID } from '../../utils/util'
import chartResize from '@/mixin/chart-resize'
export default {
  mixins: [chartResize],
  name: 'RingDiagram',
  components: {},
  data() {
    return {
      id: getUUID(),
    }
  },
  myChart: null,
  unwatch: null,
  props: {
    // id: {
    //   type: String,
    //   default: ''
    // },
    data: {
      type: Array,
      default: null,
    },
    height: {
      type: String,
      default: '200px',
    },
  },
  methods: {
    drawRingGraph() {
      let _this = this
      this.myChart = echarts2.init(document.getElementById(_this.id))
      this.unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
    set(data) {
      var option
      var data = this.data
      option = {
        color: ['#5470C6', '#91CC75', '#FAC859', '#F9CFC5'],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.7)',
          textStyle: {
            color: '#FFFFFF',
          },
          formatter: function (params) {
            var allData = 0
            var result = ''
            result +=
              '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background:' +
              params.color +
              '"></span>'
            result += params.data.name + '<br>'
            result += '&nbsp&nbsp&nbsp数量 ：' + params.data.value + '<br>'
            result += '&nbsp&nbsp&nbsp占比 ：' + params.data.percentage + '<br>'
            return result
          },
        },
        legend: {
          top: '5%',
          right: '10%',
          orient: 'vertical', //垂直显示
          padding: 5, //调节legend的位置
          formatter: function (name) {
            // var total = 0
            var percentage
            var target
            for (var i = 0, l = data.length; i < l; i++) {
              //   total += data[i].value

              if (data[i].name == name) {
                target = data[i].value
                percentage = data[i].percentage
              }
            }
            var arr = ['{a|' + name + ' \n}{b|' + target + ' (' + percentage + ')}']
            return arr.join('\n')
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 12,
                align: 'left',
                padding: [0, 0, 0, 0],
              },
              b: {
                fontSize: 12,
                align: 'left',
                padding: [2, 0, 0, 0],
                'letter-spacing': '0.48px',
                color: '#666666',
              },
            },
          },
        },
        series: [
          {
            center: ['33%', '50%'],
            // name: '访问来源',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false,
            },
            data: this.data,
          },
        ],
      }

      this.myChart.setOption(option)
      this.chartEleResizeListener()
    },
  },
  mounted() {
    this.drawRingGraph()
  },
  created() {},
  beforeDestroy() {
    if (this.unwatch) {
      this.unwatch()
      this.unwatch = null
    }
    if (!this.myChart?.isDisposed) {
      this.myChart.dispose()
    }
  },
}
</script>
<style lang="less" scoped>
</style>
